import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

const ColumnsSvg = () => {
    return (
        <SvgIcon
            sx={{
                fill: '#BEBCB9'
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="10"
                fill="none"
                viewBox="0 0 12 10"
                className={'columnSvg'}

            >
                <path
                    d="M0 4V1C0 .811.064.653.192.525A.645.645 0 01.667.333h2.216c.19 0 .348.064.475.192A.645.645 0 013.55 1v3a.645.645 0 01-.192.475.645.645 0 01-.475.192H.667a.645.645 0 01-.475-.192A.645.645 0 010 4zm4.883.667a.645.645 0 01-.475-.192A.645.645 0 014.217 4V1c0-.189.064-.347.191-.475a.645.645 0 01.475-.192h2.234c.189 0 .347.064.475.192A.645.645 0 017.783 1v3a.645.645 0 01-.191.475.645.645 0 01-.475.192H4.883zm4.234 0a.645.645 0 01-.475-.192A.645.645 0 018.45 4V1c0-.189.064-.347.192-.475a.645.645 0 01.475-.192h2.216c.19 0 .348.064.475.192A.645.645 0 0112 1v3a.645.645 0 01-.192.475.645.645 0 01-.475.192H9.117zm-6.234 5H.667a.645.645 0 01-.475-.192A.645.645 0 010 9V6c0-.189.064-.347.192-.475a.645.645 0 01.475-.192h2.216c.19 0 .348.064.475.192A.645.645 0 013.55 6v3a.645.645 0 01-.192.475.645.645 0 01-.475.192zm2 0a.645.645 0 01-.475-.192A.645.645 0 014.217 9V6c0-.189.064-.347.191-.475a.645.645 0 01.475-.192h2.234c.189 0 .347.064.475.192A.645.645 0 017.783 6v3a.645.645 0 01-.191.475.645.645 0 01-.475.192H4.883zm4.234 0a.645.645 0 01-.475-.192A.645.645 0 018.45 9V6c0-.189.064-.347.192-.475a.645.645 0 01.475-.192h2.216c.19 0 .348.064.475.192A.645.645 0 0112 6v3a.645.645 0 01-.192.475.645.645 0 01-.475.192H9.117z"
                ></path>
            </svg>
        </SvgIcon>
    );
};

export default ColumnsSvg;